import { render, staticRenderFns } from "./AdminLogList.vue?vue&type=template&id=8791d590&scoped=true&"
import script from "./AdminLogList.vue?vue&type=script&lang=js&"
export * from "./AdminLogList.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdminLogList.vue?vue&type=style&index=1&id=8791d590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8791d590",
  null
  
)

export default component.exports